/**
 * 元素可见性观察器(基于页面可视范围的 intersection observer)
 * 回调函数中，会返回元素在可视范围内的百分比 0 ~ 1
 */
import 'intersection-observer';
export function createVisibilityObserver(ratio, onChange) {
    if (ratio === void 0) { ratio = 0; }
    var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.intersectionRatio > ratio) {
            onChange && onChange(entries[0].intersectionRatio);
        }
    });
    return observer;
}
//# sourceMappingURL=visibility.js.map